import {
  MAIN_ROUTES,
} from '@/router/components';
import { UserUiDto } from '@/api';
import { BackgroundColors } from '@/@types/types';

export default {
  path: 'domains',
  meta: {
    requiresAuth: true,
    breadCrumb: 'app.navigation-drawer.domains',
  },
  component: MAIN_ROUTES.DOMAINS,
  children: [{
    path: '',
    name: 'domains',
    meta: {
      requiresAuth: true,
      hideBreadCrumb: true,
      breadCrumb: 'app.navigation-drawer.domains',
      roles: [UserUiDto.role.ADMIN],
      breadCrumbFromParamName: true,
      background: BackgroundColors.SECONDARY,
      entityKey: 'domains',
    },
    props: true,
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }, {
    path: 'add',
    name: 'domains.domain.add',
    meta: {
      requiresAuth: true,
      breadCrumb: 'domains.addDomain',
      breadCrumbFromParamName: true,
      roles: [UserUiDto.role.ADMIN],
      background: BackgroundColors.SECONDARY,

    },
    props: true,
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }, {
    path: ':id?',
    name: 'domains.domain.edit',
    meta: {
      requiresAuth: true,
      breadCrumb: 'domains.editDomain',
      roles: [UserUiDto.role.ADMIN],
      breadCrumbFromParamName: true,
      background: BackgroundColors.SECONDARY,
    },
    props: true,
    component: () => import('@/views/FrontendNextRouteView.vue'),
  }, {
    path: 'subdomains',
    meta: {
      requiresAuth: true,
      hideBreadCrumb: true,
    },
    component: MAIN_ROUTES.DOMAINS,
    children: [{
      path: 'add/:parentDomainId?',
      name: 'domains.subdomains.add',
      meta: {
        requiresAuth: true,
        breadCrumb: 'domains.subdomains.add',
        breadCrumbFromParamName: false,
        roles: [UserUiDto.role.ADMIN],
        background: BackgroundColors.SECONDARY,
      },
      props: true,
      component: () => import('@/views/FrontendNextRouteView.vue'),
    }, {
      path: ':id',
      name: 'domains.subdomains.edit',
      meta: {
        requiresAuth: true,
        breadCrumb: 'domains.subdomains.edit',
        breadCrumbFromParamName: true,
        roles: [UserUiDto.role.ADMIN],
        background: BackgroundColors.SECONDARY,
      },
      props: true,
      component: () => import('@/views/FrontendNextRouteView.vue'),
    }],
  }],
};
